type TabValues = readonly [
  'live',
  'priced',
  'filed',
  'postponed',
  'lockupExpirations',
  'myOfferings'
];

export type TabValue = TabValues[number];

export const CALENDAR_TABS: TabValues = [
  'live',
  'priced',
  'filed',
  'postponed',
  'lockupExpirations',
  'myOfferings',
];

export const CALENDAR_TAB_LABELS: Record<TabValue, string> = {
  live: 'Live',
  priced: 'Priced',
  filed: 'Filed',
  postponed: 'Postponed',
  lockupExpirations: 'Lock-Up Expirations',
  myOfferings: 'My Offerings',
};

export const getCalendarTabStorageKey = (tab: TabValue): string => {
  return `${tab}CalendarGridState`;
};
